import React from 'react';

//TODO replace with unpkg
export const Silence = () => {
  return (
    <audio src="https://100ms.live/silence.mp3" autoPlay className="hidden" />
  );
};
